import { render, staticRenderFns } from "./registergroupmodal.vue?vue&type=template&id=0accf938&"
import script from "./registergroupmodal.vue?vue&type=script&lang=js&"
export * from "./registergroupmodal.vue?vue&type=script&lang=js&"
import style0 from "./registergroupmodal.vue?vue&type=style&index=0&id=0accf938&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports